import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { requestMarkdownUrl } from '@/constants/urls';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import { downloadRequestMarkdown } from '../markdown/actions';

const DownloadRequestActionMenu = ({ downloadRequest, request, disabled }) => (
  <Dropdown
    icon={null}
    trigger={(<DownloadAction />)}
    className="aridhia-download-request-action-menu"
    disabled={disabled}
  >
    <Dropdown.Menu>
      <Dropdown.Item
        as="a"
        selected={false}
        href={requestMarkdownUrl(request, '#')}
      >
        <Icon name="file alternate outline" />
        <FormattedMessage id="actions.metadata.markdown" />
      </Dropdown.Item>
      <Dropdown.Item
        as="a"
        selected={false}
        onClick={() => downloadRequest(request.code)}
      >
        <Icon name="download" />
        <FormattedMessage id="actions.download.request" />
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);

const mapDispatchToProps = {
  downloadRequest: downloadRequestMarkdown,
};

export default connect(null, mapDispatchToProps)(DownloadRequestActionMenu);
